import angular from 'angular';

import './card.styles.scss';

import CardController from './card.controller';

export const CardComponent = {
  selector: 'abCard',
  template: /* html */ `
  <div
    class="ab-card {{ $ctrl.classes }}"
    ng-class="{ 'has-action': $ctrl.hasAction, 'ghost': $ctrl.ghost && $ctrl.ghost === true }"
    ng-click="$ctrl.cardClick()"
  >
    <div
      class="card-title-wrap"
      ng-if="($ctrl.title || $ctrl.subtitle || $ctrl.titleIcon || $ctrl.titleImage || $ctrl.titleAction || $ctrl.titleUser) && !$ctrl.ghost"
    >
      <div class="card-icon-wrap icon" ng-if="$ctrl.titleIcon">
      <svg class="ab-icon"><use xlink:href="{{ '#' + $ctrl.titleIcon }}"></use></svg>
      </div>
      <div class="card-icon-wrap" ng-if="$ctrl.titleUser">
        <profile-image user-id="{{ $ctrl.titleUser }}"></profile-image>
      </div>
      <div class="image-wrap" ng-if="$ctrl.titleImage">
        <img src="{{ $ctrl.titleImage }}">
      </div>

      <div
        class="card-text-wrap"
        ng-if="$ctrl.titleUser || $ctrl.title || $ctrl.subtitle"
      >
        <span ng-if="$ctrl.titleUser" class="card-title"><user-name user-id="$ctrl.titleUser"></user-name></span>  
        <span ng-if="$ctrl.title" class="card-title">{{ $ctrl.title }}</span>
        <span ng-if="$ctrl.subtitle" class="card-subtitle">{{ $ctrl.subtitle }}</span>
      </div>

      <div
        class="card-action-wrap"
        ng-if="$ctrl.titleAction && $ctrl.titleActionIcon"
      >
        <button type="button" class="btn-icon" ng-click="$ctrl.titleAction()">
          <svg class="ab-icon"><use xlink:href="{{ '#' + $ctrl.titleActionIcon }}"></use></svg>
        </button>
      </div>
    </div>

    <main
      ng-if="($ctrl.mainTitle || $ctrl.mainText || $ctrl.mainSubtitle || $ctrl.displayIcon || $ctrl.displayText) && !$ctrl.ghost"
    >
      <div class="display" ng-if="$ctrl.displayIcon || $ctrl.displayText">
        <div class="display-icon" ng-if="$ctrl.displayIcon">
          <svg class="ab-icon"><use xlink:href="{{ '#' + $ctrl.displayIcon }}"></use></svg>
        </div>
        <span ng-if="$ctrl.displayText" class="display-text" ng-bind-html="$ctrl.displayText"></span>
      </div>
      <span ng-if="$ctrl.mainTitle" class="main-title sm">{{ $ctrl.mainTitle }}</span>
      <span ng-if="$ctrl.mainText" class="main-text">{{ $ctrl.mainText }}</span>

      <span ng-if="$ctrl.mainSubtitle" class="main-subtitle" ng-bind-html="$ctrl.mainSubtitle"></span>
    </main>

    <div class="card-transclude" ng-transclude></div>

    <svg class="ab-icon action-icon" ng-if="$ctrl.hasAction"><use xlink:href="#arrow-right"></use></svg>

    <!-- GHOST CARD -->
    <aside ng-if="$ctrl.ghost && $ctrl.ghost === true">
      <span class="ghost-icon"></span>
    </aside>
    <main ng-if="$ctrl.ghost && $ctrl.ghost === true">
      <span class="ghost-title ghost-text"></span>
      <span class="ghost-subtitle ghost-text"></span>

      <span class="ghost-description ghost-text"></span>
    </main>
  </div>
  `,
  bindings: {
    /** Additional classes to pass eg. 'filled' */
    classes: '@?',
    /** Pass a URL to redirect on click */
    action: '@?',
    /** Call fn on click */
    fn: '&?',
    /** ab-icon icon name */
    titleIcon: '@?',
    /** URL for image */
    titleImage: '@?',
    /** Title row title */
    title: '@?',
    /** userId instead of title and icon */
    titleUser: '@?',
    /** Title row subtitle */
    subtitle: '@?',
    /** Title row action */
    titleAction: '&?',
    /** ab-icon icon name */
    titleActionIcon: '@?',
    /** Big icon */
    displayIcon: '@?',
    displayText: '@?',
    mainTitle: '@?',
    mainText: '@?',
    mainSubtitle: '@?',
    placeholder: '@?',
    ghost: '@?',
  },
  transclude: true,
  controller: CardController,
};

export default angular.module('autoboard.abCard', [])
  .component(CardComponent.selector, CardComponent)
  .name;
